module.exports = fox._r("images/btn_join.png", __webpack_public_path__ + "images/btn_join.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/btn_join.png
// module id = 1027
// module chunks = 4